import { render, staticRenderFns } from "./ListWidgetSetting.vue?vue&type=template&id=0d44d751&"
import script from "./ListWidgetSetting.vue?vue&type=script&lang=ts&"
export * from "./ListWidgetSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d44d751')) {
      api.createRecord('0d44d751', component.options)
    } else {
      api.reload('0d44d751', component.options)
    }
    module.hot.accept("./ListWidgetSetting.vue?vue&type=template&id=0d44d751&", function () {
      api.rerender('0d44d751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget-dashboard/composables/ListWidgetSetting.vue"
export default component.exports